import React, { Component } from 'react';
import FormatText from '../Utils/TextFormatter';
import playstore from '../Img/google-play-badge.svg';
import appstore from '../Img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';

export default class AlternativEnd extends Component {

    state={}

	render() {
        const {thanksText, codeExplanation, downloadExplanation, androidDownloadLink, iosDownloadLink, style} = this.props;
        const testerCode = global.SumbitResult ? global.SumbitResult.code : 'XXX'; 
        const padding = 40;

  
        return <div style={style}>
            <div style={{
                 position: "absolute",
				 bottom: 0,
				 height: 320,
                 right: padding,
                 left: padding,
                 textAlign: "right",
                 fontSize: 16,
            }}>
                <h2>{thanksText}</h2>
                <span className="separation-bar">▒▒▒▒▒</span>
                <div style={{marginTop: 16}}>{FormatText(global.isMale,codeExplanation)}</div>
                <h2 >{testerCode}</h2>
                <div >{FormatText(global.isMale,downloadExplanation)}</div>
                <div id="appstores_cont" style={{
                    position: "absolute",
                    bottom: padding,
                    right: 0,
                    left: 0,
                    display: 'flex',
                    justifyContent: 'space-evenly',
                }}>
                    <img alt="img" src={playstore} style={{marginLeft:4, height: 40}} onClick={_=>window.open(androidDownloadLink, "_blank")}/>
                    <img alt="img" src={appstore} style={{marginRight:4, height: 40}} onClick={_=>window.open(iosDownloadLink, "_blank")}/>
                </div>
            </div>

	  	</div>
    }

}



// WEBPACK FOOTER //
// ./src/Comp/AlternativEnd.js